import axios from 'axios';

export default axios.create({
    baseURL: process.env.VUE_APP_API_URL
  });

// export default axios.create({
//   baseURL: 'https://auth-tanastsoroba.ombudsman.ge/api'
// });